import React from 'react';
import Modal from 'components/Modal';

import { CHEDRI_COMMS_CENTER_PLUGIN } from 'js/constants';

import SettingsChedriCommsCenter from 'components/layout/plugin/settings/SettingsChedriCommsCenter';

class PluginSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shown: false,
    };
  }

  componentDidMount() {
    const { useModal, shown } = this.props;

    if (!useModal && !shown) {
      this.setState({ shown: true });
    }
  }

  onShow = () => {
    this.setState({ shown: true });
  };

  onExit = () => {
    this.setState({ shown: false });
  };

  renderContent = () => {
    const { plugin, whiteLabelProject } = this.props;
    const { shown } = this.state;

    if (!plugin) {
      return null;
    }

    const sharedProps = { shown, plugin, whiteLabelProject };

    return <div>{plugin.id === CHEDRI_COMMS_CENTER_PLUGIN && <SettingsChedriCommsCenter {...sharedProps} />}</div>;
  };

  render() {
    const { show, close, plugin, shown, useModal } = this.props;

    if (!useModal) {
      return this.renderContent();
    }

    return plugin ? (
      <Modal show={show} onHide={close} bsSize="lg" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{plugin.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderContent()}</Modal.Body>
      </Modal>
    ) : null;
  }
}
PluginSettings.defaultProps = {
  useModal: true,
  close: () => {},
};

export default PluginSettings;
